import { action } from 'typesafe-actions';
import { PaymentBehaviourInsightsConfiguration, PaymentBehaviourInsightsActionTypes } from './types';
import { ResponseModalObject } from '../../utils/commonInterfaces';

export const getPaymentBehaviourInsightsConfigRequestAction = () =>
    action(PaymentBehaviourInsightsActionTypes.GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST);

export const getPaymentBehaviourInsightsConfigSuccessAction = (data: PaymentBehaviourInsightsConfiguration) =>
    action(PaymentBehaviourInsightsActionTypes.GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_SUCCESS, data);

export const getPaymentBehaviourInsightsConfigErrorAction = () =>
    action(PaymentBehaviourInsightsActionTypes.GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_ERROR);
 
export const savePaymentBehaviourInsightsConfigRequestAction = (
    payload: any,
    callback?: (response: ResponseModalObject) => void
) =>
    action(PaymentBehaviourInsightsActionTypes.SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST, {
        payload,
        callback,
    });

export const savePaymentBehaviourInsightsConfigResponseAction = () =>
    action(PaymentBehaviourInsightsActionTypes.SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_RESPONSE);